import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { updateMetaTags } from '../utils/seoUtils';

const VALID_TOOL_IDS = [
  'pdf-to-image',
  'pdf-compress',
  'image-convert',
  'image-resize',
  'image-compress',
];

/**
 * SEO Head Component
 * 根據當前路由和語言動態更新 Meta 標籤
 */
const SEOHead = () => {
  const location = useLocation();
  const { currentLang } = useLanguage();

  useEffect(() => {
    // 從 hash 路由中提取工具 ID（例如 #/tool/pdf-to-image）
    const hash = window.location.hash || '';
    const hashMatch = hash.match(/\/tool\/([^/?#]+)/);
    const toolIdFromHash = hashMatch ? hashMatch[1] : null;

    // 從 pathname 提取工具 ID（備用）
    const pathParts = location.pathname.split('/');
    const toolIdFromPath = pathParts[pathParts.length - 1];

    const toolId =
      (toolIdFromHash && VALID_TOOL_IDS.includes(toolIdFromHash) ? toolIdFromHash : null) ||
      (VALID_TOOL_IDS.includes(toolIdFromPath) ? toolIdFromPath : null);

    updateMetaTags(currentLang, toolId);
    window.scrollTo(0, 0);
  }, [location, currentLang]);

  // 監聽 hash 變化（HashRouter 的工具切換）
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash || '';
      const hashMatch = hash.match(/\/tool\/([^/?#]+)/);
      const toolId = hashMatch && VALID_TOOL_IDS.includes(hashMatch[1]) ? hashMatch[1] : null;
      updateMetaTags(currentLang, toolId);
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, [currentLang]);

  return null;
};

export default SEOHead;